import { scenes } from "../scenes";
import { Scene, Choice } from "../models";

export class EmergencyRoom extends Scene {
  title = "The Emergency Room";
  async init() {
    this.audio = require("@/audio/Pandemic-27-Doctor-Stock-MP3.mp3");
    this.description =
      "DOCTOR: I told you Sonny Yang, we can’t afford to take in any more patients as it is! Please, stay home and take care of yourself.";
    this.image = require("@/images/Doctor.png");
  }
  get options(): any[] {
    return [
      new Choice("Leave", async () => await this.navigate(scenes.HospitalExterior())),
    ];
  }
}

export default new EmergencyRoom();
